import { CircularProgress, Stack, styled } from '@mui/material';

export const StyledContainer = styled(Stack)({
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#ebeef5',
});

export const StyledLoader = styled(CircularProgress)({
  color: '#6D77C8',
});
